// extracted by mini-css-extract-plugin
module.exports = {"main-component":"filledCircle_main-component__2rHY2"};